import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Button} from "primeng/button";
import {DatePicker} from "primeng/datepicker";
import {Dialog} from "primeng/dialog";
import {Fluid} from "primeng/fluid";
import {PrimeTemplate} from "primeng/api";
import {Select} from "primeng/select";
import {Manufacturer} from '../manufacturer/manufacturer';
import {Forecast} from '../forecast/forecast';
import {PlanningParameter} from '../planning-parameter/planning-parameter';
import {ForecastService} from '../forecast/forecast.service';
import {FormsModule} from '@angular/forms';
import {PlanningParameterService} from '../planning-parameter/planning-parameter.service';

@Component({
  selector: 'app-enter-new-forecast',
    imports: [
        Button,
        DatePicker,
        Dialog,
        Fluid,
        PrimeTemplate,
        Select,
        FormsModule
    ],
  templateUrl: './enter-new-forecast.html',
  styleUrl: './enter-new-forecast.scss',
})
export class EnterNewForecast {

    private _manufacturer!: Manufacturer;

    @Input() set manufacturer(value: Manufacturer) {
        this._manufacturer = value;

        if (value) {
            this.planningParameterService.getAll(value).subscribe(collection => {
                this.planningParameters = collection.getPlanningParameters();
            });
        }
    }

    get manufacturer(): Manufacturer {
        return this._manufacturer;
    }

    @Input() public visible = false;
    @Output() protected visibleChange = new EventEmitter<boolean>();
    @Output() protected saved = new EventEmitter<Forecast>();

    protected selectedPlanningParameter!: PlanningParameter;
    protected selectedMonth: Date | null = null;
    protected planningParameters!: PlanningParameter[];

    constructor(
        private forecastService: ForecastService,
        private planningParameterService: PlanningParameterService
    ) {}

    protected closeModal(): void {
        this.visibleChange.emit(false);
    }

    protected saveNewForecast(): void {
        if (!this.selectedPlanningParameter || !this.selectedMonth) {
            return;
        }

        this.forecastService.createNewForecast(
            this.selectedPlanningParameter,
            this.selectedMonth.getMonth() + 1,
            this.selectedMonth.getFullYear()
        ).subscribe(newForecast => {
            this.saved.emit(newForecast);
            this.closeModal();
        });
    }
}
